import React, { useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { api } from '../api';

// Covers the Billing screen when no shift is open. Never locks when the server can't be reached (offline billing).
function ShiftLock() {
  const [rect, setRect] = useState(null);
  const [open, setOpen] = useState(true);

  useEffect(() => {
    let alive = true;
    const check = () => {
      const el = document.querySelector('.pos-root');
      if (!el) { if (alive) setRect(null); return; }
      const r = el.getBoundingClientRect();
      if (alive) setRect({ top: r.top, left: r.left, width: r.width, height: Math.max(r.height, window.innerHeight - r.top) });
    };
    const poll = () => {
      if (!document.querySelector('.pos-root')) return;
      api.get('/shifts/open-status').then((d) => { if (alive) setOpen(d && d.open !== false); }).catch(() => { if (alive) setOpen(true); });
    };
    check(); poll();
    const t1 = setInterval(check, 800);
    const t2 = setInterval(poll, 8000);
    const nav = () => setTimeout(() => { check(); poll(); }, 300);
    window.addEventListener('icecream-navigate', nav);
    window.addEventListener('focus', poll);
    window.addEventListener('resize', check);
    return () => { alive = false; clearInterval(t1); clearInterval(t2); window.removeEventListener('icecream-navigate', nav); window.removeEventListener('focus', poll); window.removeEventListener('resize', check); };
  }, []);

  if (!rect || open) return null;
  return (
    <div style={{ position: 'fixed', top: rect.top, left: rect.left, width: rect.width, height: rect.height, zIndex: 1500,
      background: 'rgba(248,246,255,.88)', backdropFilter: 'blur(4px)', WebkitBackdropFilter: 'blur(4px)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div style={{ background: '#fff', borderRadius: 20, padding: '28px 30px', maxWidth: 440, textAlign: 'center', boxShadow: '0 20px 60px rgba(33,20,74,.18)', border: '1px solid #ece8f6' }}>
        <div style={{ fontSize: 44 }}>🔒</div>
        <div style={{ fontSize: 20, fontWeight: 800, margin: '8px 0 6px', color: '#231a33' }}>No shift is open</div>
        <div style={{ fontSize: 15, color: '#6b6280', marginBottom: 18 }}>Start the shift to begin billing. Every bill must be inside a shift so the cash and stock match at handover.</div>
        <button type="button" onClick={() => window.dispatchEvent(new CustomEvent('icecream-navigate', { detail: 'shifts' }))}
          style={{ height: 48, padding: '0 22px', border: 0, borderRadius: 12, background: '#6948dc', color: '#fff', fontWeight: 800, fontSize: 16, cursor: 'pointer', font: 'inherit' }}>
          Go to Shift Handover →
        </button>
      </div>
    </div>
  );
}

export function mountShiftLock() {
  if (document.getElementById('shift-lock-root')) return;
  const el = document.createElement('div'); el.id = 'shift-lock-root'; document.body.appendChild(el);
  createRoot(el).render(<ShiftLock />);
}
